import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '@irb-common/http-interceptors/auth-interceptor';
import { ErrorHttpInterceptor } from '@irb-common/http-interceptors/error-interceptor';

export const httpInterceptorProviders: any = [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];